"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decreaseProfileAssetsCount = decreaseProfileAssetsCount;
exports.increaseProfileAssetsCount = increaseProfileAssetsCount;
exports.setActiveOrganization = setActiveOrganization;
exports.setFeatureFlags = setFeatureFlags;
exports.setSession = setSession;
exports.setToken = setToken;
exports.setUserProperty = setUserProperty;
exports.updateActiveOrganization = updateActiveOrganization;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _authServerClient = require("@mulesoft/auth-server-client");
var actions = _interopRequireWildcard(require("./actionTypes"));
var sessionSelectors = _interopRequireWildcard(require("./selectors"));
var _utils = require("./utils");
var _analytics = require("../../utils/analytics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ORGANIZATION_CHANGED = 'Organization changed';
function setSession(session) {
  return _objectSpread({
    type: actions.SET_SESSION
  }, session);
}
function setToken(accessToken, tokenType) {
  return {
    accessToken: accessToken,
    tokenType: tokenType,
    type: actions.SET_TOKEN
  };
}
function setFeatureFlags(featureFlags) {
  return {
    type: actions.SET_FEATURE_FLAGS,
    featureFlags: featureFlags
  };
}
function setUserProperty(_ref) {
  var namespace = _ref.namespace,
    key = _ref.key,
    value = _ref.value;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref2) {
      var config, state, profile, userId, organizationId, context, userService;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref2.config;
            if (namespace) {
              _context.next = 3;
              break;
            }
            throw new Error('namespace is mandatory');
          case 3:
            if (key) {
              _context.next = 5;
              break;
            }
            throw new Error('key is mandatory');
          case 5:
            if (value) {
              _context.next = 7;
              break;
            }
            throw new Error('value is mandatory');
          case 7:
            state = getState();
            profile = sessionSelectors.profile(state);
            if (profile) {
              _context.next = 11;
              break;
            }
            throw new Error('Profile not found');
          case 11:
            userId = profile.id, organizationId = profile.organization.id;
            context = sessionSelectors.context(state);
            userService = new _authServerClient.UserService(config);
            _context.next = 16;
            return userService.setUserProperty({
              context: context,
              organizationId: organizationId,
              userId: userId,
              namespace: namespace,
              key: key,
              value: value
            });
          case 16:
            dispatch({
              type: actions.SET_USER_PROPERTY,
              namespace: namespace,
              key: key,
              value: value
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function increaseProfileAssetsCount() {
  return {
    type: actions.INCREASE_PROFILE_ASSETS_COUNT
  };
}
function decreaseProfileAssetsCount() {
  return {
    type: actions.DECREASE_PROFILE_ASSETS_COUNT
  };
}
function setActiveOrganization(organization) {
  return _objectSpread({
    type: actions.SET_ACTIVE_ORGANIZATION,
    organization: organization
  }, (0, _analytics.clientTrackPayload)({
    eventSchema: ORGANIZATION_CHANGED
  }));
}
function updateActiveOrganization(organization, homeQuery, push, getPath) {
  return function (dispatch, getState, _ref4) {
    var config = _ref4.config;
    var state = getState();
    var profile = sessionSelectors.profile(state);
    var activeOrganizationId = (0, _utils.getActiveOrganizationId)(profile);
    var newPath = (0, _utils.getPathAfterOrganizationChange)(homeQuery, activeOrganizationId, organization.id, config, getPath);
    dispatch(setActiveOrganization(organization));
    push(newPath);
  };
}
//# sourceMappingURL=actions.js.map